import React from 'react';
import { useRecoilState } from 'recoil';
import { w_labels, chosen_lang } from '../RecoilState';

const Text = ({ index, style, value }) => {

    const [c_lang, setCLang] = useRecoilState(chosen_lang);

    // console.error("Lang text");
    // console.log(value);

    // console.log("text.jsx");
    // console.log(labels);
    // console.log(c_lang);

    return (
        <>
            {
                (c_lang.code === "bn") ?
                    (
                        <p className={style}>{value.bn}</p>
                    ) :
                    (c_lang.code === "hi") ?
                        (
                            <p className={style}>{value.hi}</p>
                        ) :
                        (c_lang.code === "fr") ?
                            (
                                <p className={style}>{value.fr}</p>
                            ) :
                            (c_lang.code === "sw") ?
                                (
                                    <p className={style}>{value.sw}</p>
                                ) :
                                (c_lang.code === "asm") ?
                                    (
                                        <p className={style}>{value.asm}</p>
                                    ) :
                                    (c_lang.code === "te") ?
                                        (
                                            <p className={style}>{value.te}</p>
                                        ) :
                                        <p className={style}>{value.en}</p>
            }
        </>
    )

}

export default Text